import apiPrivate from "./apiPrivate.service";
import { apiPublic } from "./apiPublic.service";

const API_URL = "/auth";

class AuthService {
    async register(credentials) {
        try {
            const response = await apiPublic.post(`${API_URL}/register`, credentials);
            return response.data;
        } catch (error) {
            console.error("Error during registration:", error?.message || "unknown error");
            throw error;
        }
    }

    async login(credentials) {
        try {
            const response = await apiPublic.post(`${API_URL}/login`, credentials, { withCredentials: true });
            return response.data;
        } catch (error) {
            console.error("Error during login:", error?.message || "unknown error");
            throw error;
        }
    }

    async logout() {
        try {
            const response = await apiPrivate.post(`${API_URL}/logout`, null, { withCredentials: true });
            return response.data;
        } catch (error) {
            console.error("Error during logout:", error?.message || "unknown error");
            throw error;
        }
    }

    async fetchUser() {
        try {
            const response = await apiPrivate.get(`${API_URL}/me`, { withCredentials: true });
            return response.data;
        } catch (error) {
            console.error("Error fetching user data:", error?.message || "unknown error");
            throw error;
        }
    }

    async refreshToken() {
        try {
            const response = await apiPublic.post(`${API_URL}/refresh-token`, null, { withCredentials: true });
            return response.data;
        } catch (error) {
            console.error("Error refreshing token:", error?.message || "unknown error");
            throw error;
        }
    }

    async changePassword(passwordData) {
        try {
            const response = await apiPrivate.put(`${API_URL}/change-password`, passwordData, { withCredentials: true });
            return response.data;
        } catch (error) {
            console.error("Error changing password:", error?.message || "unknown error");
            throw error;
        }
    }

}

export default new AuthService();